(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rcl-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  var track = document.getElementById('rclReviewTrack-{{ section.id }}');
  var prev = document.getElementById('rclRevPrev-{{ section.id }}');
  var next = document.getElementById('rclRevNext-{{ section.id }}');
  if(!track) return;
  function step(){var card=track.querySelector('.rcl-review-card');if(!card)return 340;var gap=parseFloat(getComputedStyle(track).gap)||20;return card.getBoundingClientRect().width+gap;}
  next&&next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
  prev&&prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
  var down=false,startX=0,startScroll=0;
  track.addEventListener('pointerdown',function(e){down=true;startX=e.clientX;startScroll=track.scrollLeft;track.style.cursor='grabbing';});
  window.addEventListener('pointerup',function(){down=false;track.style.cursor='';});
  track.addEventListener('pointermove',function(e){if(!down)return;track.scrollLeft=startScroll-(e.clientX-startX);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcl-showroom"] && !Shopify.designMode) return;
  try {
    
(function(){
  var v = document.querySelector('#showroom-section .rcl-showroom-video');
  if(!v) return;
  v.muted = true; v.setAttribute('muted','');
  function tryPlay(){var p=v.play();if(p&&p.catch)p.catch(function(){});}
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting)tryPlay();else v.pause();});},{threshold:0.25}).observe(v);
  } else {tryPlay();}
  document.addEventListener('visibilitychange',function(){if(!document.hidden)tryPlay();});
})();

  } catch(e) { console.error(e); }
})();
})();
